import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HERO_IMG = "https://images.pexels.com/photos/30889597/pexels-photo-30889597.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const PROOF = [
  ["11", "interest and personality dimensions"],
  ["Class-specific", "questions, chosen for the student's exact class"],
  ["Classes 7–12", "for students in classes 7-12"],
];

function HeroVisual() {
  return (
    <div className="relative mx-auto w-full max-w-[460px] lg:ml-auto lg:mr-0">
      <div className="relative ml-auto w-[82%] aspect-[4/5] overflow-hidden rounded-t-[999px] rounded-b-[24px] border border-ds-plum/15">
        <img src={HERO_IMG} alt="Students in school uniform standing together in a classroom" className="h-full w-full object-cover" loading="eager" />
      </div>
      <figure className="absolute -left-2 sm:left-0 bottom-[-28px] w-[52%] rotate-[-3deg] rounded-[10px] bg-white p-1.5 shadow-[0_18px_40px_-18px_rgba(79,3,65,0.45)] border border-ds-plum/10" data-testid="hero-report-page">
        <img src="/report-pages/clusters.webp" alt="A page from the Disha sample report showing career cluster matches" className="w-full rounded-[6px]" loading="eager" />
      </figure>
      <svg className="absolute left-[44%] bottom-[22%] w-20 h-14 text-ds-amber hidden sm:block" viewBox="0 0 80 56" fill="none" aria-hidden="true">
        <path d="M74 6 C58 8 40 18 30 34 C26 40 24 44 22 48" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
        <path d="M14 42 L22 50 L28 40" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
}

export default function Hero() {
  return (
    <>
      <section className="relative overflow-hidden bg-ds-cream" data-testid="landing-hero">
        <div className="contour absolute inset-y-0 right-0 w-full lg:w-[55%]" aria-hidden="true" />
        <div className="container-x relative pt-12 pb-20 lg:pt-20 lg:pb-28 grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-6 space-y-7" data-reveal>
            <p className="text-sm font-semibold text-ds-plum">Career discovery for Classes 7 to 12</p>
            <h1 className="font-display text-[40px] sm:text-6xl lg:text-[68px] font-semibold leading-[1.08] text-ds-plumdeep" data-testid="landing-hero-title">
              Discover what you love.{" "}
              <span className="relative inline-block text-ds-plum">
                See where it can take you.
                <svg className="absolute -bottom-2 left-0 w-full h-3 text-ds-amber" viewBox="0 0 300 12" preserveAspectRatio="none" fill="none" aria-hidden="true">
                  <path d="M3 8 C70 2 150 3 297 6" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                </svg>
              </span>
            </h1>
            <p className="text-[17px] sm:text-lg text-ds-inksoft max-w-xl leading-relaxed">
              A gentle, guided journey that helps students find a direction that fits who they are becoming, and helps families talk about the future with calm and confidence.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 pt-1">
              <Link to="/sample-report" data-testid="landing-hero-report-cta" className="ds-btn bg-ds-plum text-white hover:bg-[#3d0232]">See a sample report</Link>
              <Link to="/signup" data-testid="landing-hero-start-cta" className="ds-btn border-[1.5px] border-ds-plum text-ds-plum hover:bg-ds-plum/5">Start the journey <ArrowRight className="h-4 w-4" /></Link>
            </div>
          </div>
          <div className="lg:col-span-6" data-reveal><HeroVisual /></div>
        </div>
      </section>
      <section className="bg-ds-creamalt border-y border-ds-plum/10" data-testid="hero-strip">
        <ul className="container-x grid sm:grid-cols-3">
          {PROOF.map(([big, label], i) => (
            <li key={big} className={`py-8 sm:px-8 flex sm:block items-baseline gap-4 ${i ? "border-t sm:border-t-0 sm:border-l border-dashed border-ds-plum/25" : ""}`} data-testid={`hero-strip-${i}`}>
              <p className="font-display text-3xl lg:text-4xl font-semibold text-ds-plum shrink-0">{big}</p>
              <p className="sm:mt-1.5 text-[15px] text-ds-inksoft">{label}</p>
            </li>
          ))}
        </ul>
      </section>
    </>
  );
}
